<template>
  <user-center-wrap>
    <div class="apply_anchor">
      <div class="other_state" v-if="userState == 1">
        <img
          :src="
            this.$i18n.locale === 'zh-CN'
              ? require('@/assets/user/zh.png')
              : this.$i18n.locale === 'vi-VN'
              ? require('@/assets/user/vi.png')
              : require('@/assets/user/en.png')
          "
          alt=""
        />
        <!-- <div class="other_title">认证成功</div>
        <div class="other_text">恭喜你！获得新的用户身份</div> -->
        <!-- <div class="other_btn" @click="findLook">查看</div> -->
      </div>
      <div class="other_state" v-else-if="userState == 2">
        <!-- <img src="../../assets/img/user-center/apply-anchor/fail.png" alt="" />
        <div class="other_text">认证未通过</div>
        <div class="other_btn" @click="resetCommit">重试</div>
        <div class="other_s_title" @click="toIndex">暂不认证</div> -->
      </div>
      <div class="other_state" v-else-if="userState == 0">
        <!-- <img
          src="../../assets/img/user-center/apply-anchor/examine.png"
          alt=""
        />
        <div class="other_text">您的主播申请已提交，请等待工作人员审核</div> -->
      </div>
      <div v-else-if="userState == 3" style="text-align: center">
        <img
          style="width: 141px; height: 113px; margin-top: 200px"
          :src="require('@/assets/user/noData.png')"
          alt=""
        />
        <br />
        <p
          style="margin-top: 50px; font-size: 14px; color: rgba(96, 98, 102, 1)"
        >
          {{ $t("live.noAnchor") }}
        </p>
      </div>
      <!-- <template v-else-if="userState == 3">
        <div class="title">申请主播</div>
        <div class="page_name">主播认证信息页</div>
        <el-form
          :inline="true"
          class="demo-form-inline"
          label-width="77px"
          label-position="left"
          :style="{ pointerEvents: currentFind ? 'none' : 'auto' }"
        >
          <el-form-item label="直播类型:" required>
            <el-select v-model="applyInfo.live_categories" placeholder="" style="width: 304px" :popper-append-to-body="false">
              
							<el-option label="足球" value="1"></el-option>
				      <el-option label="篮球" value="2"></el-option>
				      <el-option label="电影" value="3"></el-option>
				      <el-option label="搞笑" value="4"></el-option>
				      <el-option label="其他" value="5"></el-option>
							
              <el-option v-for="(item, index) in categoryData" :key="index" :label="item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="直播经验:" required>
            <el-select v-model="applyInfo.live_career" placeholder="" style="width: 304px">
              <el-option label="0-3个月" value="1"></el-option>
              <el-option label="3-6个月" value="3"></el-option>
              <el-option label="6-12个月" value="6"></el-option>
              <el-option label="12个月以上" value="12"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="主播姓名:" required>
            <el-input v-model="applyInfo.real_name" :readonly="currentFind" style="width: 304px" placeholder="请输入真实姓名" @input="changeName">
            </el-input>
          </el-form-item>
          <el-form-item label="联系QQ:">
            <el-input
              :readonly="currentFind"
              v-model="applyInfo.qq"
              placeholder="请输入您的QQ号"
              style="width: 304px"
              @input="changeQQ"
              maxlength="12"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="联系微信:">
            <el-input :readonly="currentFind" v-model="applyInfo.we_chat" style="width: 304px" placeholder="请输入您的微信号" @input="changeWX">
            </el-input>
          </el-form-item>
          <el-form-item label="身份证号:" required>
            <el-input
              :readonly="currentFind"
              v-model="applyInfo.id_num"
              placeholder="请输入身份证号码"
              style="width: 304px"
              @input="changeId"
              maxlength="18"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="身份证照:" required>
            <div style="display: flex">
              <el-upload
                class="avatar-uploader"
                :action="uploadfileUrl"
                :show-file-list="false"
                :auto-upload="true"
                :multiple="false"
                :http-request="handleAvatarSuccess1"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl1" :src="imageUrl1" class="avatar" />
                <div v-else class="upload_img upload_img_1">
                  
				          <img src="./img/home_tianjia.png" alt="" />
				          <div class="text">身份证正面</div>
									
                </div>
              </el-upload>
              <el-upload
                class="avatar-uploader"
                :action="uploadfileUrl"
                :show-file-list="false"
                :auto-upload="true"
                :multiple="false"
                :http-request="handleAvatarSuccess2"
                :before-upload="beforeAvatarUpload"
              >
                <img v-if="imageUrl2" :src="imageUrl2" class="avatar" />
                <div v-else class="upload_img upload_img_2">
                  
				          <img src="./img/home_tianjia.png" alt="" />
				          <div class="text">身份证反面</div>
									
                </div>
              </el-upload>
              <el-upload
                class="avatar-uploader"
                :action="uploadfileUrl"
                :show-file-list="false"
                :auto-upload="true"
                :multiple="false"
                :http-request="handleAvatarSuccess3"
                :before-upload="beforeAvatarUpload"
                style="margin-right: 0"
              >
                <img v-if="imageUrl3" :src="imageUrl3" class="avatar" />
                <div v-else class="upload_img upload_img_3">
                  
				          <img src="./img/home_tianjia.png" alt="" />
				          <div class="text">手持身份证</div>
									
                </div>
              </el-upload>
            </div>
          </el-form-item>
          <el-form-item label="个人介绍:" required>
            <el-input
              type="textarea"
              :rows="7"
              placeholder="请输入不少于15字的简介(例如主播经验几年、在哪些平台上担任过主播、曾得过哪些荣誉、擅长直播哪类赛事等)"
              v-model="applyInfo.desc"
              style="width: 768px"
              maxlength="255"
              show-word-limit
              :readonly="currentFind"
            >
            </el-input>
          </el-form-item>
          <el-form-item label="手机号码:" required>
            <el-input v-model="userInfo.formatPhone" style="width: 304px" placeholder="请输入您的手机号" maxlength="11" readonly> </el-input>
          </el-form-item>
          <el-form-item label="推荐人:" v-if="!currentFind">
            <el-input v-model="applyInfo.referrer" placeholder="请输入推荐人名称（非必填）" style="width: 304px"> </el-input>
          </el-form-item>
          <el-form-item label="验证码:" v-if="!currentFind" required>
            <el-input v-model="applyInfo.smscode" placeholder="请输入验证码" style="width: 304px" maxlength="6">
              <div
                slot="suffix"
                :style="{
                  color: '#02A8A2',
                  background: 'transparent',
                  padding: '0px 10px',
                }"
                :class="[!isSend ? 'send_class' : 'last_down_time']"
                @click.stop="beforeSendCode"
              >
                {{ sendText }}
              </div>
            </el-input>
          </el-form-item>
          <el-form-item style="width: 100%" v-if="!currentFind">
            <div class="flex-row">
              <el-checkbox v-model="radio"></el-checkbox>
              <div :style="{ paddingLeft: '5px' }">
                阅读并同意<span style="color: #02a8a2; cursor: pointer" @click="dialogVisible = true">《直播协议》</span>
              </div>
            </div>
          </el-form-item>
          <div class="submit_btn_panel flex-middle" v-if="!currentFind">
            <div class="submit_btn" @click="onSubmit">确认提交</div>
          </div>

          <SlideVerify
            v-if="showSlideVerify"
            class="slide-verify-pos"
            :h="171"
            :w="280"
            :sw="40"
            :sh="49"
            @success="verifySuccess"
            @close="showSlideVerify = false"
          />
        </el-form>
      </template> -->
      <el-dialog
        title="直播协议"
        :visible.sync="dialogVisible"
        width="50%"
        center
      >
        <div class="help-panel">
          <div v-html="helpContent"></div>
        </div>
        <span slot="footer" class="dialog-footer flex-row justify-end">
          <!-- <div @click="dialogVisible = false">取 消</div> -->
          <div class="submit_btn" @click="dialogVisible = false">确 定</div>
        </span>
      </el-dialog>
    </div>
  </user-center-wrap>
</template>

<script>
import { post, get } from "../../util/http";
import { mapState } from "vuex";
import UserCenterWrap from "../../components/user-center-wrap/user-center-wrap";
// import host from "../../util/host";
import IdentityCodeValid from "@/util/IdentityCodeValid";
import SlideVerify from "@/components/slide-verify";
import uploadByCosSdk from "@/mixins/uploadByCosSdk";

export default {
  mixins: [uploadByCosSdk],
  components: {
    UserCenterWrap,
    SlideVerify,
  },
  data() {
    return {
      pageLoading: true,
      applyInfo: {
        desc: "",
        id_card_url: "",
        id_num: "",
        live_career: "",
        live_categories: "",
        qq: "",
        real_name: "",
        we_chat: "",
        referrer: "",
        mobile: "",
        smscode: "",
      },
      radio: true,
      uploadfileUrl:
        ENV === "dev" ? "/proxy/api/user/file" : API_URL + "/api/user/file",
      imageUrl1: "",
      imageUrl2: "",
      imageUrl3: "",
      isSend: false,
      sendText: "点击发送",
      userState: 3, //默认状态
      authInfo: {},
      currentFind: false,
      categoryData: [],
      dialogVisible: false,
      showSlideVerify: false,
      helpContent: "",
    };
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  created() {
    this.userState = this.$store.state.userState;
    // console.log("this.userInfo: ", this.userInfo);
    this.getLiveMenus();
    this.getHelp();
  },
  mounted() {
    this.getAuthInfo();
  },
  methods: {
    beforeSendCode() {
      if (this.isSend) return;

      this.showSlideVerify = true;
    },

    verifySuccess() {
      this.showSlideVerify = false;
      this.sendCode();
    },

    toIndex() {
      this.$router.push({ path: "/" });
    },
    getLiveMenus() {
      post({
        url: "/api/live/liveMenus",
      })
        .then(({ data: res }) => {
          console.log("res: ", res);

          if (res.status === 0) {
            let categoryData = [];
            let category_data = res.data.category_data || [];
            category_data.forEach(({ second_category = [] }) => {
              second_category = second_category || [];
              categoryData.push(...second_category);
            });
            this.categoryData = categoryData;

            // this.categoryData = res.data.category_data || [];
            // this.$router.push("/");
            // this.$message.success("您的主播申请已提交，请等待工作人员审核");
          }
        })
        .catch((err) => {
          // this.$message.success(e.message);
          console.log("getLiveMenus err: ", err);
        });
    },
    resetCommit() {
      this.userState = 3;
    },
    findLook() {
      this.userState = 3;
      this.currentFind = true;
      this.applyInfo.desc = this.authInfo.desc;
      this.applyInfo.real_name = this.authInfo.real_name;
      this.applyInfo.qq = this.authInfo.qq;
      this.applyInfo.we_chat = this.authInfo.we_chat;
      this.applyInfo.id_num = this.authInfo.id_num;
      this.applyInfo.live_categories = this.authInfo.live_categories + "";
      this.applyInfo.live_career = this.authInfo.live_career + "";
      this.imageUrl1 = this.authInfo.imgs[0];
      this.imageUrl2 = this.authInfo.imgs[1];
      this.imageUrl3 = this.authInfo.imgs[2];
      this.$nextTick(() => {
        document.querySelectorAll(
          ".apply_anchor .el-select__caret"
        )[0].style.display = "none";
        document.querySelectorAll(
          ".apply_anchor .el-select__caret"
        )[1].style.display = "none";
      });
    },
    async getAuthInfo() {
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/auth/getAuthInfo",
      });
      console.log(data, "----");
      if (status == 0) {
        this.userState = data.status;
        this.$store.commit("setUserState", data.status);
        this.authInfo = data;
      }
    },
    onSubmit() {
      if (!this.applyInfo.live_categories) {
        return this.$message.warning("直播类型不能为空");
      }
      if (!this.applyInfo.live_career) {
        return this.$message.warning("直播经验不能为空");
      }
      if (!this.applyInfo.real_name) {
        return this.$message.warning("主播姓名不能为空");
      }
      /*
      if (!this.applyInfo.qq) {
        return this.$message.warning("联系QQ不能为空");
      }
      if (!this.applyInfo.we_chat) {
        return this.$message.warning("联系微信不能为空");
      }
			*/
      if (!this.applyInfo.id_num) {
        return this.$message.warning("身份证不能为空");
      } else {
        let data1 = this.applyInfo.id_num.toUpperCase();
        console.log("身份证", data1);
        if (!IdentityCodeValid(data1)) {
          return this.$message.warning("身份证格式不正确");
        }
      }
      if (!this.imageUrl1 || !this.imageUrl2 || !this.imageUrl3) {
        return this.$message.warning("身份证照片不能为空");
      }
      if (!this.applyInfo.desc) {
        return this.$message.warning("个人介绍不能为空");
      }
      if (!this.applyInfo.desc.length) {
        return this.$message.warning("个人介绍不能为空");
      }
      if (!this.applyInfo.desc.length) {
        return this.$message.warning("个人介绍不能为空");
      }
      if (this.applyInfo.desc.length < 15) {
        return this.$message.warning("个人介绍不能小于15个字");
      }
      if (this.radio == false) {
        return this.$message.warning("猎鹰直播协议未勾选");
      }
      if (!this.applyInfo.smscode) {
        return this.$message.warning("验证码不能为空");
      }
      if (this.applyInfo.smscode.length != 6) {
        return this.$message.warning("验证码必须为6位");
      }

      post({
        url: "/api/auth/identityAuth",
        data: {
          ...this.applyInfo,
          id_card_url: `${this.imageUrl1},${this.imageUrl2},${this.imageUrl3}`,
          live_career: Number(this.applyInfo.live_career),
          live_categories: Number(this.applyInfo.live_categories),
          mobile: this.userInfo.mobile,
        },
      })
        .then(({ data: res = {} }) => {
          if (res.status === 0) {
            this.$router.push("/");
            this.$message.success("您的主播申请已提交，请等待工作人员审核");
          }
        })
        .catch((err = {}) => {
          console.log(err);
        });
    },
    async sendCode() {
      if (this.isSend) return;
      const {
        data: { data, status, msg },
      } = await post({
        url: "/api/user/sendVerifyCode",
        data: { mobile: this.userInfo.mobile },
      });
      console.log(data, "-----");
      if (status == 0) {
        this.isSend = true;
        let time = 60;
        this.sendText = time + "s";
        let timeId = setInterval(() => {
          time--;
          this.sendText = time + "s";
          if (time <= 0) {
            this.sendText = "重新发送";
            this.isSend = false;
            clearInterval(timeId);
          }
        }, 1000);
      }
    },
    handleAvatarSuccess1(res, file) {
      console.log("handleAvatarSuccess1", file);
      this.upload(res.file).then((result) => {
        if (result.status === 0) {
          console.log("handleAvatarSuccess1", result);
          this.imageUrl1 = result.data;
        }
      });
    },
    handleAvatarSuccess2(result) {
      this.upload(result.file).then((res) => {
        if (res.status === 0) {
          this.imageUrl2 = res.data;
        }
      });
    },
    handleAvatarSuccess3(result, file) {
      this.upload(result.file).then((res) => {
        if (res.status === 0) {
          this.imageUrl3 = res.data;
        }
      });
    },
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isGIF = file.type === "image/gif";
      const isPNG = file.type === "image/png";
      const isBMP = file.type === "image/bmp";
      const isLt2M = file.size / 1024 / 1024 < 2;
      const flieArr = file.name.split("."); // 根据.分割数组
      let suffix = flieArr[flieArr.length - 1]; // 取最后一个
      if ((!isJPG && !isGIF && !isPNG && !isBMP) || suffix == "jfif") {
        this.$message.error("上传图片必须是JPG/GIF/PNG/BMP 格式!");
        return false;
      }
      if (!isLt2M) {
        this.message.error("上传图片大小不能超过 2MB!");
      }
      return (isJPG || isBMP || isGIF || isPNG) && isLt2M;
    },
    changeQQ(value) {
      let val = value.trim();
      this.applyInfo.qq = val.replace(/\D/g, "");
    },
    changeName(value) {
      // let val = value.trim();
      //this.applyInfo.real_name = val.replace(/[^\u4E00-\u9FA5]/g, "");
    },
    changeId(value) {
      let val = value.trim();
      this.applyInfo.id_num = val.replace(/[^\d\x\X]/g, "");
    },
    changeWX(value) {
      let val = value.trim();
      this.applyInfo.we_chat = val.replace(/[^a-z0-9_]/g, "");
    },
    getHelp() {
      post({
        url: "/api/help/getHelpById",
        data: {
          id: 3,
        },
      }).then(({ data: res }) => {
        let { status = "", data = null } = res;
        if (status === 0 && data) {
          this.helpContent = data.content || "";
        }
      });
    },
  },
};
</script>

<style scoped lang="stylus">

.slide-verify-pos {
  position: absolute;
  max-width: 350px;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  background-color: #fff;
}

.apply_anchor{
  padding-top:16* 0.01rem;
  padding-left:40* 0.01rem;
  padding-right: 25* 0.01rem;
  .other_state{
    text-align: center;
    margin-top: 300 * .01rem;
    img{
      width : 180 * .01rem;
      height 180 * .01rem;
    }
    .other_text{
			margin : 20*.01rem 0* 0.01rem;
      font-size: 15* 0.01rem;
      color: #A9A9A9;
    }
		.other_title{
			// margin : 30px 0* 0.01rem;
			margin-top :30* 0.01rem;
			font-size: 20* 0.01rem;
			color: #666666;
		}
		.other_s_title{
			color: #02A8A2;
			line-height : 20* 0.01rem;
			cursor : pointer;
			margin-top :10* 0.01rem;
		}
    .other_btn{
			width: 108* 0.01rem;
			height: 33* 0.01rem;
			background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
			margin : 0 auto;
			border-radius: 5* 0.01rem;
      text-align: center;
      line-height: 33* 0.01rem;
      font-size: 15* 0.01rem;
      color: #ffffff;
      margin-top:16* 0.01rem;
      cursor pointer;
    }
  }
  .title{
    font-weight: 500;
    font-size: 20* 0.01rem;
    line-height: 28* 0.01rem;
    color: #333333;
    position:relative;
    width:72* 0.01rem;
    text-align: center;
    z-index:2;
  }
		/*
		.title:before {
			content: '';
			position: absolute;
			left: 0;
			bottom: -3* 0.01rem;
			width:100%
			height:6* 0.01rem;
			background:#26d99d;
			border-radius: 35* 0.01rem;
			z-index:-1;
		}
		*/
   .page_name{
     font-size: 14* 0.01rem;
     color: #333333;
     font-weight: 400;
     font-size: 16* 0.01rem;
     line-height: 22* 0.01rem;
     margin-top: 40* 0.01rem;
     margin-bottom: 30* 0.01rem;
		 padding-bottom : 10* 0.01rem;
		 border-bottom : 1px solid #F0F0F0;
   }
	 .submit_btn_panel{
		 margin-bottom : 40* 0.01rem;
	 }
	 .submit_btn{
	 			font-size: 18* 0.01rem;
	 			width: 108* 0.01rem;
	 			height: 33* 0.01rem;
	 			line-height :33* 0.01rem;
	 			background: linear-gradient(90deg, #29F19C 0%, #02A1F9 100%);
	 			text-align: center;
	 			color: #ffffff;
	 			cursor pointer;
	 			border-radius: 5* 0.01rem;
	 }

   .upload_img{
				width: 244* 0.01rem;
        height: 147* 0.01rem;
        // background: #F7F7F7;
				//background: url(../../assets/img/user-center/apply-anchor/card-z.png) no-repeat;
				&.upload_img_1{
					background-image: url(../../assets/img/user-center/apply-anchor/card-z.png);
				}
				&.upload_img_2{
					background-image: url(../../assets/img/user-center/apply-anchor/card-f.png);
				}
				&.upload_img_3{
					background-image: url(../../assets/img/user-center/apply-anchor/card-r.png);
				}
				background-repeat: no-repeat;
				background-size : 100% 100%;
        // border: 1.53px solid #F0F0F0;
        border-radius: 6.1* 0.01rem;
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        >img{
            width: 24 * .01rem;
            height: 24 * .01rem;
        }
        .text{
            font-size: 12* 0.01rem;
            color: #666666;
            margin-top:16* 0.01rem;
            line-height: 0;
        }

   }
   .avatar-uploader{
        margin-right: 16* 0.01rem;
        .avatar{
          width: 244* 0.01rem;
          height: 137* 0.01rem;
        }
    }
		.help-panel{
			height : 400* 0.01rem;
			overflow-y: auto;
		}
		/deep/ .el-checkbox__input .el-checkbox__inner{
			border-radius : 50%;
		}
		/deep/ .el-checkbox__input.is-checked .el-checkbox__inner{
			background: #02A8A2;
		}
		/deep/ .el-form--inline .el-form-item{
		    margin-right: 80* 0.01rem;
		    margin-bottom: 30* 0.01rem;
		}
		/deep/ .el-icon-arrow-up:before{
			content: ""
			transform : rotate(180deg);
			display:block;
		}
		/deep/ .el-form--inline .el-form-item__label{
			text-align : right;
		}
}
/*

/deep/ .el-form--inline .el-form-item__label{
    font-size: 14* 0.01rem;
    color:#666;
}
/deep/ .el-textarea__inner{
    resize: none;
}
/deep/ .el-input--small .el-input__inner{
  height 40px
}
*/
</style>
